import { render, staticRenderFns } from "./DesiredValuesModal.vue?vue&type=template&id=d229843e&scoped=true&"
import script from "./DesiredValuesModal.vue?vue&type=script&lang=js&"
export * from "./DesiredValuesModal.vue?vue&type=script&lang=js&"
import style0 from "./DesiredValuesModal.vue?vue&type=style&index=0&id=d229843e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d229843e",
  null
  
)

export default component.exports